import { render } from "./HotTopicsView.vue?vue&type=template&id=17b0650c&scoped=true"
import script from "./HotTopicsView.vue?vue&type=script&lang=js"
export * from "./HotTopicsView.vue?vue&type=script&lang=js"

import "./HotTopicsView.vue?vue&type=style&index=0&id=17b0650c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b0650c"]])

export default __exports__